<template>
  <div ref="fullscreenReporte" class="hph-fullscreen-root">
    <v-row class="hph-filters-row">
      <v-col cols="12" md="4">
        <v-autocomplete v-model="filtros.IdMaquinIns" :items="instancias" :item-text="nombreMaquina"
          item-value="idMaquinaIns" label="Máquina (Obligatorio)" :loading="loadingHpH || loadingInstancias"
          :disabled="loadingHpH || loadingInstancias" @change="getHpH()" />
      </v-col>
      <v-col cols="12" md="4">
        <datePicker v-model="filtros.Fecha" format="YYYY-MM-DD" label="Fecha (Obligatorio)" :loading="loadingHpH"
          :disabled="loadingHpH" maxToday @input="getHpH()" />
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete v-model="filtros.IdTurno" :items="turnos" item-text="nombre" item-value="idTurno"
          label="Turno (Obligatorio)" :loading="loadingHpH || loadingTurnos" :disabled="loadingHpH || loadingTurnos"
          @change="getHpH()" />
      </v-col>
    </v-row>
    <v-row class="hph-date-range-row" align="center">
      <v-col cols="12" md="4">
        <datePicker v-model="filtros.InicioReporte" format="YYYY-MM-DD" label="Inicio reporte por fechas"
          :loading="loadingReporteFechas" :disabled="loadingHpH || loadingReporteFechas" clearable maxToday />
      </v-col>
      <v-col cols="12" md="4">
        <datePicker v-model="filtros.FinReporte" format="YYYY-MM-DD" label="Fin reporte por fechas"
          :loading="loadingReporteFechas" :disabled="loadingHpH || loadingReporteFechas" clearable maxToday />
      </v-col>
      <v-col cols="12" md="4">
        <v-btn block color="primary" :disabled="!puedeDescargarReporteFechas" :loading="loadingReporteFechas"
          @click="descargarReporteFechas">
          <v-icon left>mdi-file-excel</v-icon>
          Descargar Excel por fechas
        </v-btn>
      </v-col>
    </v-row>
    <div class="d-flex align-center">
      <!-- <FilterSyncIndicator :expectedFilters="filtros" :appliedFilters="ultimosFiltros" class="mr-2" /> -->
      <!-- <v-btn color="primary" @click="getHpH()" :loading="loadingHpH" :disabled="!filtrosCorrectos">Consultar</v-btn> -->
    </div>
    <div v-if="showReloadingBar" class="hph-reload-bar">
      <v-progress-linear color="primary" height="3" indeterminate />
    </div>

    <LoaderData :loading="showInitialLoading" :response="data" :error="errorHpH">
      <v-col cols="12">
        <v-row class="align-center hph-toolbar">
          <div class="hph-toolbar-main">
            <CountDownSearch v-if="yaConsultado" v-model="consultaData" :permitirDesactivarConsulta="false"
              :pausado="cuentaPausada" :duracion-segundos="300" :recordarProgreso="true" :recargando="loadingHpH"
              @recargaManual="getHpH()" />
          </div>
          <v-spacer></v-spacer>
          <div class="rounded-pill grey lighten-4 mb-2 mx-1 d-inline-flex elevation-1 hph-toolbar-main">
            <v-tooltip bottom color="black">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="false" v-bind="attrs" v-on="on" small fab class="mx-1"
                  :color="modoDatos === 'Tabla' ? 'primary' : 'blue lighten-5'" :aria-pressed="modoDatos === 'Tabla'"
                  @click="cambioPrefModo('Tabla')">
                  <v-icon small :color="modoDatos === 'Tabla' ? 'white' : 'blue darken-2'">mdi-table-large</v-icon>
                </v-btn>
              </template>
              <span class="white--text">Tabla</span>
            </v-tooltip>
            <v-tooltip bottom color="black">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                  :color="modoDatos === 'Grafica' ? 'primary' : 'blue lighten-5'"
                  :aria-pressed="modoDatos === 'Grafica'" @click="cambioPrefModo('Grafica')">
                  <v-icon small :color="modoDatos === 'Grafica' ? 'white' : 'blue darken-2'">mdi-chart-bar</v-icon>
                </v-btn>
              </template>
              <span class="white--text">Gráfica</span>
            </v-tooltip>
          </div>
          <div class="rounded-pill grey lighten-4 mb-2 mx-1 d-inline-flex elevation-1 hph-toolbar-main">
            <v-tooltip bottom color="blue-grey darken-4">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                  :color="modoGrupo === 'Articulos' ? 'deep-purple darken-2' : 'deep-purple lighten-5'"
                  :aria-pressed="modoGrupo === 'Articulos'" @click="cambioPrefGrup('Articulos')">
                  <v-icon small :color="modoGrupo === 'Articulos' ? 'white' : 'deep-purple darken-2'">
                    mdi-package-variant-closed
                  </v-icon>
                </v-btn>
              </template>
              <span class="white--text">Por artículo</span>
            </v-tooltip>

            <v-tooltip bottom color="blue-grey darken-4">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                  :color="modoGrupo === 'Cavidades' ? 'teal darken-2' : 'teal lighten-5'"
                  :aria-pressed="modoGrupo === 'Cavidades'" @click="cambioPrefGrup('Cavidades')">
                  <v-icon small :color="modoGrupo === 'Cavidades' ? 'white' : 'teal darken-2'">
                    mdi-robot-industrial
                  </v-icon>
                </v-btn>
              </template>
              <span class="white--text">Por cavidad</span>
            </v-tooltip>
          </div>

          <div v-if="configReporte.configReporte" class="rounded-pill mb-2 mx-1 d-inline-flex hph-toolbar-main">
            <v-tooltip bottom color="blue-grey darken-4">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" small fab class="mx-1" color="orange darken-2"
                  @click="abrirConfigReporte()">
                  <v-icon small color="white">
                    mdi-cog-outline
                  </v-icon>
                </v-btn>
              </template>
              <span class="white--text">Ajustes</span>
            </v-tooltip>
          </div>
          <div class="rounded-pill mb-2 mx-1 d-inline-flex hph-fullscreen-toggle">
            <v-tooltip bottom color="blue-grey darken-4">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" small fab class="mx-1" color="success" @click="toggleFullscreenReporte">
                  <v-icon color="white">
                    {{ isFullscreenReporte ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}
                  </v-icon>
                </v-btn>
              </template>
              <span class="white--text">
                {{ isFullscreenReporte ? 'Salir de pantalla completa' : 'Pantalla completa' }}
              </span>
            </v-tooltip>
          </div>
        </v-row>
      </v-col>
      <v-tabs-items v-model="modoDatos">
        <v-tab-item v-if="!isFullscreenReporte" value="Tabla">
          <v-card flat>
            <HpHTabla v-model="data" :tiempoMuerto="isLOGI" :modoGrupo="modoGrupo" />
          </v-card>
        </v-tab-item>

        <v-tab-item value="Grafica">
          <v-card flat>
            <HpHGrafica v-model="data" :tiempoMuerto="isLOGI" :modoGrupo="modoGrupo" :configReporte="configReporte"
              :mostrarTablaODT="!isFullscreenReporte" @update-config-reporte="actualizarConfigReporteDesdeGrafica"
              @ver-paros="abrirDialogoParos()" @ver-no-ok="abrirDialogoNoOk()" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </LoaderData>

    <v-dialog v-model="dialogParosHpH" persistent width="80%">
      <v-card>
        <v-card-title>Historial de paros</v-card-title>
        <v-card-text>
          <DialgoParosHpH :value="dialogPayload" :detallesParos="dialogPayload.DetallesParos" />
        </v-card-text>
        <v-card-actions>
          <v-btn class="ml-auto" color="primary" @click="dialogParosHpH = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogNoOkHpH" persistent width="80%">
      <v-card>
        <v-card-title>Piezas No OK</v-card-title>
        <v-card-text>
          <DialgoNoOkHpH :value="dialogPayload" />
        </v-card-text>
        <v-card-actions>
          <v-btn class="ml-auto" color="primary" @click="dialogNoOkHpH = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfig" persistent width="auto">
      <v-card>
        <v-card-title>
          Ajustes del reporte
          <v-spacer></v-spacer>
        </v-card-title>
        <LoaderData :loading="loadingPrefs" :response="configReporte">
          <v-card-text>
            <v-col cols="12">
              <span class="text-subtitle-2">Mostrar selector de piezas hechas, esperadas y rate:</span>
              <v-switch v-model="configReporte.mostrarKPIsGrafica" inset color="primary" hide-details
                :label="configReporte.mostrarKPIsGrafica ? 'Sí' : 'No'" />
              <br>
              <span class="text-subtitle-2">Calcular disponibilidad:</span>
              <v-radio-group v-model="configReporte.usarDisponibilidad" row>
                <v-radio label="Sí" :value="true" />
                <v-radio label="No" :value="false" />
              </v-radio-group>
              <div v-if="configReporte.usarDisponibilidad">
                <span class="text-subtitle-2">Paros que afectan la disponibilidad:</span>
                <v-container dense>
                  <v-checkbox v-model="configReporte.progAfectaDisp" label="Paros programados" />
                  <v-checkbox v-model="configReporte.noProgAfectaDisp" label="Paros no programados" />
                </v-container>
              </div>
              <div>
                <span class="text-subtitle-2">Paros que afectan las piezas esperadas:</span>
                <v-container dense>
                  <v-checkbox v-model="configReporte.progAfectaEsperadas" label="Paros programados" />
                  <v-checkbox v-model="configReporte.noProgAfectaEsperadas" label="Paros no programados" />
                </v-container>
              </div>
              <div v-if="false">
                <span class="text-subtitle-2">Formato para nombre de artículo</span>
                <v-radio-group v-model="configReporte.formatoArticulo" mandatory>
                  <v-radio :key="1" label="Código" value="1" />
                  <v-radio :key="2" label="Nombre" value="2" />
                  <v-radio :key="3" label="[Código] - Nombre" value="3" />
                </v-radio-group>
              </div>
              <div v-if="gamemode">
                <span class="text-subtitle-2">Opciones de desarrollador:</span>
                <v-switch v-model="configReporte.configReporte" label="Configuración accesible al usuario" />
              </div>
            </v-col>
          </v-card-text>
        </LoaderData>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="reestablecerConfigReporte()">Reestablecer ajustes</v-btn>
          <v-btn color="success" text @click="cerrarConfigReporte()">Cancelar</v-btn>
          <v-btn color="error" text @click="guardarConfigReporte()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <VisibilitySignal @deactivated="pausarBusqueda()" @activated="reanudarBusqueda()" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import CountDownSearch from '../../../CountDownSearch.vue';
import FilterSyncIndicator from '../../../FilterSyncIndicator.vue';
import LoaderData from '../../../LoaderData.vue';
import HpHTabla from './HpHTabla.vue';
import HpHGrafica from './HpHGrafica.vue';
import DialgoParosHpH from '../ReportesOEE/DialgoParosHpH.vue';
import DialgoNoOkHpH from '../ReportesOEE/DialgoNoOkHpH.vue';

const getDefaultConfigReporte = () => ({
  mostrarKPIsGrafica: true,
  usarDisponibilidad: true,
  progAfectaDisp: true,
  noProgAfectaDisp: true,
  mostrarHechas: true,
  mostrarEsperadas: true,
  mostrarRate: true,
  progAfectaEsperadas: true,
  noProgAfectaEsperadas: true,
  configReporte: false,
  formatoArticulo: 3,
});

export default {
  components: {
    CountDownSearch,
    FilterSyncIndicator,
    HpHTabla,
    HpHGrafica,
    DialgoParosHpH,
    DialgoNoOkHpH,
  },
  data() {
    return {
      modoDatos: "Grafica",
      modoGrupo: "Articulos",

      filtros: {
        IdMaquinIns: null,
        Fecha: null,
        IdTurno: null,
        InicioReporte: null,
        FinReporte: null,
      },
      ultimosFiltros: {
        IdMaquinIns: null,
        Fecha: null,
        IdTurno: null,
      },

      configReporte: getDefaultConfigReporte(),

      turnos: [],
      instancias: [],
      data: [],

      errorHpH: false,
      loadingHpH: false,
      loadingReporteFechas: false,
      loadingPrefs: false,
      loadingInstancias: false,
      loadingTurnos: false,
      consultaData: true,
      cuentaPausada: false,
      yaConsultado: false,
      dialogParosHpH: false,
      dialogNoOkHpH: false,
      dialogConfig: false,
      isFullscreenReporte: false,
      modoDatosPrevFullscreen: null,

      codigoReporte: "r41",
    }
  },
  methods: {
    nombreMaquina: (maquina) => `[${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
    normalizarConfigReporte(cfg = {}) {
      const source = cfg && typeof cfg === 'object' ? cfg : {};
      return {
        mostrarKPIsGrafica: source.mostrarKPIsGrafica !== false,
        usarDisponibilidad: source.usarDisponibilidad !== false,
        progAfectaDisp: source.progAfectaDisp !== false,
        noProgAfectaDisp: source.noProgAfectaDisp !== false,
        mostrarHechas: source.mostrarHechas !== false,
        mostrarEsperadas: source.mostrarEsperadas !== false,
        mostrarRate: source.mostrarRate !== false,
        progAfectaEsperadas: source.progAfectaEsperadas !== false,
        noProgAfectaEsperadas: source.noProgAfectaEsperadas !== false,
        configReporte: source.configReporte === true,
        formatoArticulo: source.formatoArticulo ?? 3,
      };
    },
    extraerConfigReporte(pref = null) {
      if (!pref) return {};

      if (typeof pref === 'string') {
        try {
          return JSON.parse(pref);
        } catch (error) {
          return {};
        }
      }

      if (typeof pref !== 'object') return {};

      const rawConfigJson = pref.configJson ?? pref.ConfigJson;
      if (rawConfigJson != null) {
        if (typeof rawConfigJson === 'string') {
          try {
            return JSON.parse(rawConfigJson);
          } catch (error) {
            return {};
          }
        }
        if (typeof rawConfigJson === 'object') {
          return rawConfigJson;
        }
      }

      return pref;
    },

    getTurnos() {
      this.loadingInstancias = true;
      axios
        .get("/Turnos")
        .then(res => this.turnos = res.data)
        .finally(() => {
          this.loadingInstancias = false;
        })
    },
    getInstancias() {
      this.loadingTurnos = true;
      axios
        .get('/MaquinaInstancias')
        .then(res => this.instancias = res.data)
        .finally(() => {
          this.loadingTurnos = false;
        })
    },
    getPreferenciasReporte() {
      axios
        .get(`ReportesConfig/Obtener/${this.codigoReporte}`)
        .then(res => {
          const prefNube = this.normalizarConfigReporte(this.extraerConfigReporte(res.data));
          this.configReporte = { ...prefNube };
          this.guardarPrefLocal(prefNube);
        })
        .catch(error => {
          const prefDefault = this.normalizarConfigReporte();
          this.configReporte = { ...prefDefault };
          this.guardarPrefLocal(prefDefault);
          this.putPreferenciasReporte(prefDefault);
        })
    },
    putPreferenciasReporte(data) {
      const pref = this.normalizarConfigReporte(this.extraerConfigReporte(data));
      this.loadingPrefs = true;
      axios
        .post(`ReportesConfig/Guardar/`, {
          codigoReporte: this.codigoReporte,
          configJson: JSON.stringify(pref),
        })
        .then(res => {
          this.configReporte = { ...pref };
          this.guardarPrefLocal(pref);
          this.cerrarConfigReporte();
        })
        .finally(() => { this.loadingPrefs = false })
    },
    actualizarConfigReporteDesdeGrafica(nuevaConfig) {
      const actual = this.normalizarConfigReporte(this.configReporte);
      const cambios = this.extraerConfigReporte(nuevaConfig);
      const next = this.normalizarConfigReporte({
        ...actual,
        ...cambios,
      });

      this.configReporte = { ...next };
      this.guardarPrefLocal(next);
    },
    n(v) {
      const x = Number(v);
      return Number.isFinite(x) ? x : 0;
    },
    normalizarRespuestaHpH(raw) {
      if (!raw || typeof raw !== "object") return {};

      const legacyRows = raw?.datosHoraViewModel ?? raw?.DatosHoraViewModel;
      if (Array.isArray(legacyRows)) return raw;

      const odts = raw?.odTs ?? raw?.ODTs;
      if (Array.isArray(odts)) return this.transformarRespuestaV2(raw);

      return raw;
    },
    transformarRespuestaV2(maquina) {
      const odts = Array.isArray(maquina?.odTs) ? maquina.odTs : [];
      const opDetalles = [];
      const rowsByHora = {};
      const noOkMap = new Map();
      const oeeRoot = maquina?.oeeCalculado || {};

      const addNoOk = (motivo) => {
        const causa = String(motivo?.nombreTipoParo || "").trim();
        const subCausa = String(motivo?.nombreSubTipoParo || "").trim();
        const key = `${causa}::${subCausa}`;

        const prev = noOkMap.get(key) || {
          Causa: causa || "SIN CAUSA",
          SubCausa: subCausa || "",
          PiezasReportadas: 0,
        };

        prev.PiezasReportadas += this.n(motivo?.piezasNoOk);
        noOkMap.set(key, prev);
      };

      const getSegundosParo = (paro = {}) => {
        const directos = this.n(paro?.segundos);
        if (directos > 0) return directos;

        const inicio = paro?.inicio ? new Date(paro.inicio) : null;
        const fin = paro?.fin ? new Date(paro.fin) : null;
        if (!inicio || !fin) return 0;

        const diff = Math.round((fin.getTime() - inicio.getTime()) / 1000);
        return diff > 0 ? diff : 0;
      };

      const mapearParoAgrupado = (paro = {}) => {
        const segundos = getSegundosParo(paro);
        return {
          Inicio: paro?.inicio,
          Fin: paro?.fin,
          Causa: paro?.nombreTipoParo || "SIN ESPECIFICAR",
          SubCausa: paro?.nombreSubTipoParo || "",
          IdsParos: Array.isArray(paro?.idsParo) ? paro.idsParo : [],
          Segundos: segundos,
          segundos,
          paroProgramado: paro?.paroProgramado === true,
          paroNoProgramado: paro?.paroNoProgramado === true,
        };
      };

      odts.forEach((odt) => {
        const operaciones = Array.isArray(odt?.operaciones) ? odt.operaciones : [];

        operaciones.forEach((op) => {
          const idOperacion = op?.idOperacion;
          if (idOperacion == null) return;

          const opOee = op?.oeeCalculado || {};
          opDetalles.push({
            idOperacion,
            idArticulo: op?.idArticulo,
            nombreArticulo: op?.nombreArticulo || op?.codigoArticulo || "",
            nombreToken: op?.nombreTokenExtra || (op?.idTokenExtra != null ? `Cavidad ${op.idTokenExtra}` : ""),
            clave: odt?.claveTrabajoOrden || "",
            tiempoMinXUnidad: this.n(op?.tiempoMinXUnidad),
            nombreInstanciaMaquina: maquina?.nombreMaquina || "",
            idTrabajoOrden: odt?.idTrabajoOrden ?? null,
            idTrabajoOrdenDetalle: odt?.idTrabajoOrdenDetalle ?? null,
            oee: this.n(opOee?.oee),
            disponibilidad: this.n(opOee?.disponibilidad),
            eficiencia: this.n(opOee?.rendimiento),
            calidad: this.n(opOee?.calidad),
            piezasEsperadas: this.n(opOee?.piezasEsperadas ?? op?.piezasEsperadas),
            piezasHechas: this.n(opOee?.piezasHechas ?? op?.piezasHechas),
          });

          (Array.isArray(op?.motivosNoOk) ? op.motivosNoOk : []).forEach(addNoOk);

          (Array.isArray(op?.horas) ? op.horas : []).forEach((hora) => {
            const ini = hora?.inicio || null;
            const fin = hora?.fin || null;
            if (!ini || !fin) return;

            const key = `${ini}|${fin}`;
            if (!rowsByHora[key]) {
              rowsByHora[key] = {
                inicio: ini,
                fin,
                operaciones: [],
                segundosParoProgramado: 0,
                segundosParoNoProgramado: 0,
                totalSegundosMuertos: 0,
              };
            }

            const row = rowsByHora[key];
            const segProg = this.n(hora?.segundosParoProgramado);
            const segNoProg = this.n(hora?.segundosParoNoProgramado);

            row.segundosParoProgramado = Math.max(row.segundosParoProgramado, segProg);
            row.segundosParoNoProgramado = Math.max(row.segundosParoNoProgramado, segNoProg);

            row.operaciones.push({
              idOperacion,
              piezasEsperadas: this.n(hora?.piezasEsperadas),
              piezasEsperadasReales: this.n(hora?.piezasEsperadas),
              piezasEsperadasCrudas: this.n(hora?.piezasEsperadas),
              piezasEsperadasCrudasReales: this.n(hora?.piezasEsperadas),
              piezasHechas: this.n(hora?.piezasHechas),
              piezasHechasReales: this.n(hora?.piezasHechas),
              piezasOk: this.n(hora?.piezasOk),
              piezasNoOk: this.n(hora?.piezasNoOk),
              segundosConOperacion: this.n(hora?.segundosConOperacion),
              segundosParoProgramado: segProg,
              segundosParoNoProgramado: segNoProg,
              tiempoMinXUnidad: this.n(op?.tiempoMinXUnidad),
            });
          });
        });
      });

      const datosHoraViewModel = Object.values(rowsByHora)
        .sort((a, b) => String(a?.inicio || "").localeCompare(String(b?.inicio || "")));

      const detallesODTOperacionesMap = new Map();
      opDetalles.forEach((item) => {
        if (!detallesODTOperacionesMap.has(item.idOperacion)) {
          detallesODTOperacionesMap.set(item.idOperacion, item);
        }
      });

      const parosAgrupados = Array.isArray(maquina?.parosAgrupados) ? maquina.parosAgrupados : [];
      const detallesParosAgrupados = parosAgrupados.map(mapearParoAgrupado);
      const detallesParosOperacion = [];
      odts.forEach((odt) => {
        (Array.isArray(odt?.operaciones) ? odt.operaciones : []).forEach((op) => {
          (Array.isArray(op?.paros) ? op.paros : []).forEach((paro) => {
            const segundos = getSegundosParo(paro);
            detallesParosOperacion.push({
              Inicio: paro?.inicio,
              Fin: paro?.fin,
              Causa: paro?.nombreTipoParo || "SIN ESPECIFICAR",
              SubCausa: paro?.nombreSubTipoParo || "",
              IdsParos: Array.isArray(paro?.idsParo) ? paro.idsParo : [],
              Segundos: segundos,
              segundos,
              paroProgramado: paro?.paroProgramado === true,
              paroNoProgramado: paro?.paroNoProgramado === true,
            });
          });
        });
      });
      const detallesParos = detallesParosAgrupados.length ? detallesParosAgrupados : detallesParosOperacion;

      const segParoProg = parosAgrupados.reduce((total, paro) => {
        const segundos = getSegundosParo(paro);
        return total + (paro?.paroProgramado === true ? segundos : 0);
      }, 0);
      const segParoNoProg = parosAgrupados.reduce((total, paro) => {
        const segundos = getSegundosParo(paro);
        return total + (paro?.paroNoProgramado === true ? segundos : 0);
      }, 0);
      const totalSegundosMuertos = parosAgrupados.reduce((total, paro) => total + getSegundosParo(paro), 0);

      return {
        idMaquinaIns: maquina?.idMaquinaIns ?? null,
        instanciaNombre: maquina?.nombreMaquina || "",
        nombreMaquina: maquina?.nombreMaquina || "",
        detallesODTOperaciones: Array.from(detallesODTOperacionesMap.values()),
        datosHoraViewModel,
        resultadosOEE: {
          aplicaOEE: oeeRoot?.aplicaOEE !== false,
          disponibilidad: this.n(oeeRoot?.disponibilidad),
          eficiencia: this.n(oeeRoot?.rendimiento),
          calidad: this.n(oeeRoot?.calidad),
          oee: this.n(oeeRoot?.oee),
        },
        segundosParoProgramado: segParoProg,
        segundosParoNoProgramado: segParoNoProg,
        totalSegundosMuertos,
        DetallesParos: detallesParos,
        DetallesNoOk: Array.from(noOkMap.values()),
      };
    },

    sincronizarRangoReporteConFecha() {
      if (!this.filtros.Fecha) return;
      if (!this.filtros.InicioReporte) this.filtros.InicioReporte = this.filtros.Fecha;
      if (!this.filtros.FinReporte) this.filtros.FinReporte = this.filtros.Fecha;
    },
    getHpH() {
      if (!this.filtrosCorrectos) return
      this.sincronizarRangoReporteConFecha();
      const params = new URLSearchParams();

      const { Desde, Hasta } = this.rangoFechasPorTurno(this.filtros.Fecha, this.filtros.IdTurno);

      params.append("idsMaquinasIns", this.filtros.IdMaquinIns);
      params.append("Inicio", Desde);
      params.append("Fin", Hasta);
      params.append("calcularPorHoras", true);
      params.append("IdsTurnos", this.filtros.IdTurno);
      params.append("GuardarDetallesOPRs", true);
      if (this.isNYX) params.append("ParosNoProgAfectaEsperadas", false);

      const url = `OEEV2/ReporteOEEMultiplesMaquinas?${params.toString()}`;

      this.errorHpH = false;
      this.loadingHpH = true;
      axios
        .get(url)
        .then(response => {
          this.yaConsultado = true;
          const rawData = Array.isArray(response?.data) ? response.data[0] : response?.data;
          this.data = this.normalizarRespuestaHpH(rawData);
        })
        .catch(error => {
          this.errorHpH = true
        })
        .finally(() => {
          this.loadingHpH = false;
        })
    },
    descargarReporteFechas() {
      if (!this.puedeDescargarReporteFechas) return;

      const params = new URLSearchParams();
      params.append("idMaquinaIns", this.filtros.IdMaquinIns);
      params.append("idTurno", this.filtros.IdTurno);
      params.append("inicio", this.filtros.InicioReporte);
      params.append("fin", this.filtros.FinReporte);

      this.loadingReporteFechas = true;
      const filename = `reporte-maquinas-hora-por-hora-${this.filtros.InicioReporte}-${this.filtros.FinReporte}.xlsx`;
      axios({
        url: `/Reportes/XlsxReporteAcumuladoMaquinaPorFechas?${params.toString()}`,
        method: "GET",
        responseType: "blob",
      })
        .then(response => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingReporteFechas = false;
        });
    },

    async toggleFullscreenReporte() {
      const el = this.$refs.fullscreenReporte;
      if (!el) return;

      const anyEl = el;
      const anyDoc = document;
      const fullscreenElement =
        document.fullscreenElement ||
        anyDoc.webkitFullscreenElement ||
        anyDoc.msFullscreenElement;
      const isOurFullscreen = !!fullscreenElement && fullscreenElement === this.$refs.fullscreenReporte;

      if (!isOurFullscreen) {
        this.modoDatosPrevFullscreen = this.modoDatos;
        if (this.modoDatos !== "Grafica") {
          this.modoDatos = "Grafica";
        }

        if (anyEl.requestFullscreen) return anyEl.requestFullscreen();
        if (anyEl.webkitRequestFullscreen) return anyEl.webkitRequestFullscreen();
        if (anyEl.msRequestFullscreen) return anyEl.msRequestFullscreen();
        return;
      }

      if (document.exitFullscreen) return document.exitFullscreen();
      if (anyDoc.webkitExitFullscreen) return anyDoc.webkitExitFullscreen();
      if (anyDoc.msExitFullscreen) return anyDoc.msExitFullscreen();
    },
    syncFullscreenReporte() {
      const anyDoc = document;
      const fullscreenElement =
        document.fullscreenElement ||
        anyDoc.webkitFullscreenElement ||
        anyDoc.msFullscreenElement;
      const wasFullscreen = this.isFullscreenReporte;
      const isFullscreen = !!fullscreenElement && fullscreenElement === this.$refs.fullscreenReporte;

      this.isFullscreenReporte = isFullscreen;

      if (isFullscreen) {
        if (this.modoDatos !== "Grafica") {
          this.modoDatos = "Grafica";
        }
        return;
      }

      if (wasFullscreen && this.modoDatosPrevFullscreen != null) {
        this.modoDatos = this.modoDatosPrevFullscreen;
        this.modoDatosPrevFullscreen = null;
      }
    },

    cambioPrefModo(modo) {
      localStorage.setItem("modoHpH", modo);
      this.modoDatos = modo;
    },
    cambioPrefGrup(modo) {
      localStorage.setItem("grupoHpH", modo);
      this.modoGrupo = modo;
    },

    rangoFechasPorTurno(fechaYYYYMMDD, idTurno) {
      const pad = (n) => String(n).padStart(2, "0");

      const toLocalIso = (d) =>
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

      const turno = (this.turnos || []).find(t => t.idTurno === idTurno);
      if (!turno) return { Desde: null, Hasta: null };

      const desde = new Date(`${fechaYYYYMMDD}T${turno.inicio}`);
      let hasta = new Date(`${fechaYYYYMMDD}T${turno.fin}`);

      // Si cruza medianoche (ej. 19:00 -> 07:00), el fin es al día siguiente
      if (hasta <= desde) hasta.setDate(hasta.getDate() + 1);

      return { Desde: toLocalIso(desde), Hasta: toLocalIso(hasta) };
    },

    pausarBusqueda() {
      this.cuentaPausada = true;
    },
    reanudarBusqueda() {
      this.cuentaPausada = false;
    },
    abrirDialogoParos() {
      this.dialogParosHpH = true;
    },
    abrirDialogoNoOk() {
      this.dialogNoOkHpH = true;
    },

    abrirConfigReporte() {
      this.configReporte = { ...this.recuperarPrefLocal() };
      this.dialogConfig = true;
    },
    cerrarConfigReporte() {
      this.configReporte = { ...this.recuperarPrefLocal() };
      this.dialogConfig = false;
    },
    reestablecerConfigReporte() {
      const prefActual = this.normalizarConfigReporte(this.recuperarPrefLocal());
      let data = {
        ...getDefaultConfigReporte(),
        configReporte: prefActual.configReporte === true,
      };
      this.putPreferenciasReporte(data);
    },
    guardarConfigReporte() {
      this.putPreferenciasReporte(this.configReporte);
    },

    guardarPrefLocal(pref) {
      const normalizada = this.normalizarConfigReporte(this.extraerConfigReporte(pref));
      localStorage.setItem(this.codigoReporte, JSON.stringify(normalizada));
    },
    recuperarPrefLocal() {
      try {
        const data = localStorage.getItem(this.codigoReporte);
        if (!data) return this.normalizarConfigReporte();
        return this.normalizarConfigReporte(this.extraerConfigReporte(JSON.parse(data)));
      } catch (error) {
        return this.normalizarConfigReporte();
      }
    },

    initialice() {
      this.getTurnos();
      this.getInstancias();
      this.getPreferenciasReporte();
    }
  },
  mounted() {
    this.initialice();
    const pref = localStorage.getItem("modoHpH") || "Grafica"
    const agrup = localStorage.getItem("grupoHpH") || "Articulos"
    this.modoDatos = pref;
    this.modoGrupo = agrup;
    this._syncFullscreenReporte = () => this.syncFullscreenReporte();
    document.addEventListener("fullscreenchange", this._syncFullscreenReporte);
    document.addEventListener("webkitfullscreenchange", this._syncFullscreenReporte);
    document.addEventListener("MSFullscreenChange", this._syncFullscreenReporte);
    this.syncFullscreenReporte();
  },
  beforeDestroy() {
    if (!this._syncFullscreenReporte) return;
    document.removeEventListener("fullscreenchange", this._syncFullscreenReporte);
    document.removeEventListener("webkitfullscreenchange", this._syncFullscreenReporte);
    document.removeEventListener("MSFullscreenChange", this._syncFullscreenReporte);
  },
  computed: {
    showInitialLoading() {
      return this.loadingHpH && !this.yaConsultado;
    },
    showReloadingBar() {
      return this.loadingHpH && this.yaConsultado;
    },
    gamemode() {
      return localStorage.getItem("gamemode") === "true";
    },
    ...mapState({
      nombreEmpresa: 'nombreEmpresa',
    }),
    isCAZEL() {
      const nombre = this.nombreEmpresa.toLowerCase();
      return nombre === "cazel" || nombre === "cazel-tlt";
    },
    isNYX() {
      const nombre = this.nombreEmpresa.toLowerCase();
      return nombre === "nyx";
    },
    isLOGI() {
      const nombre = this.nombreEmpresa.toLowerCase();
      return nombre === "logistorage";
    },
    filtrosCorrectos() {
      const f = this.filtros;
      return f.IdMaquinIns != null && f.Fecha != null && f.IdTurno;
    },
    puedeDescargarReporteFechas() {
      const f = this.filtros;
      return (
        f.IdMaquinIns != null &&
        f.IdTurno != null &&
        f.InicioReporte != null &&
        f.FinReporte != null &&
        f.InicioReporte <= f.FinReporte
      );
    },
    dialogPayload() {
      return this.data && typeof this.data === 'object' && !Array.isArray(this.data)
        ? this.data
        : {};
    }
  },
  watch: {
    "filtros.Fecha"() {
      if (!this.filtros.Fecha) return;
      this.sincronizarRangoReporteConFecha();
    },
    "configReporte.usarDisponibilidad"(nv) {
      if (nv) {
        this.configReporte.progAfectaDisp = true;
        this.configReporte.noProgAfectaDisp = true;
      }
    }
  }
}
</script>

<style scoped>
.hph-reload-bar {
  margin-bottom: 8px;
}

.hph-fullscreen-root:fullscreen,
.hph-fullscreen-root:-webkit-full-screen {
  background: #ffffff;
  overflow: auto;
}

.hph-fullscreen-root:fullscreen .hph-filters-row,
.hph-fullscreen-root:-webkit-full-screen .hph-filters-row,
.hph-fullscreen-root:fullscreen .hph-toolbar-main,
.hph-fullscreen-root:-webkit-full-screen .hph-toolbar-main {
  display: none !important;
}

.hph-fullscreen-root:fullscreen .hph-fullscreen-toggle,
.hph-fullscreen-root:-webkit-full-screen .hph-fullscreen-toggle {
  margin-left: auto;
}

.hph-fullscreen-root:fullscreen .hph-reload-bar,
.hph-fullscreen-root:-webkit-full-screen .hph-reload-bar {
  position: sticky;
  top: 0;
  z-index: 3;
}
</style>
